export const findKeyBySuffix = (
  obj: Record<string, unknown>,
  suffix: string
) => {
  return Object.keys(obj).find((key) => key.endsWith(suffix));
};
